var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlagDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 121,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.54 59.272l-17.388 3.654 11.77 13.148-10.291 7.54-9.156-15.2-9.156 15.2-10.485-7.54 11.603-12.778-17.396-4.024 3.926-12.063 16.094 6.893-1.303-17.534h13.056l-2.052 17.233 16.666-6.79 4.111 12.261zM68 120.5V.5H.57v120l33.71-33.337L68 120.5z",
    fill: "#222F64"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjgiIGhlaWdodD0iMTIxIiB2aWV3Qm94PSIwIDAgNjggMTIxIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNTkuNTM5NCA1OS4yNzIyTDQyLjE1MTggNjIuOTI1NUw1My45MjI1IDc2LjA3NDFMNDMuNjMwOCA4My42MTM0TDM0LjQ3NDkgNjguNDE0MUwyNS4zMTg5IDgzLjYxMzRMMTQuODMzNSA3Ni4wNzQxTDI2LjQzNyA2My4yOTZMOS4wNDA1OCA1OS4yNzIyTDEyLjk2NzEgNDcuMjA5M0wyOS4wNjA1IDU0LjEwMjRMMjcuNzU3NSAzNi41NjgxSDQwLjgxMzZMMzguNzYyMyA1My44MDA4TDU1LjQyOCA0Ny4wMTExTDU5LjUzOTQgNTkuMjcyMlpNNjcuOTk5OSAxMjAuNVYwLjVIMC41NzEyODlWMTIwLjVMMzQuMjgxMiA4Ny4xNjMzTDY3Ljk5OTkgMTIwLjVaIiBmaWxsPSIjMjIyRjY0Ii8+Cjwvc3ZnPgo=";
export { SvgFlagDesktop as ReactComponent };